import {NgModule} from '@angular/core';
import {HttpModule} from '@angular/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {FilterComponent} from './components/filter/filter.component';
import {SpinnerComponent} from './components/spinner/spinner.component';
import {PaginationComponent} from './components/pagination/pagination.component';
import {RecipientsFilterViewComponent} from './components/email-merge/recipients-filter-view/recipients-filter-view.component';
import {ViewAttachmentModalComponent} from './views/email/view-attachment-modal/view-attachment-modal.component';
import {SearchSelectComponent} from './components/search-select/search-select.component';
import {SvgCheckedComponent} from './components/svg/checked.component';
import {SvgHalfCheckedComponent} from './components/svg/halfchecked.component';
import {SearchInstructionsModalComponent} from './views/email/search-instructions-modal/search-instructions-modal.component';
import {SignatureFieldComponent} from './components/signature-field/signature-field.component';
import {CommonModule} from '@angular/common';
import {ScrollableDirective} from 'app/directives/scrollable.directive';
import {QuickSearchComponent} from './components/quick-search/quick-search.component';
import {RouterModule} from '@angular/router';
import {NgHighlightModule} from 'ngx-text-highlight';
import {FiltersViewComponent} from './components/filters-view/filters-view.component';
import {BroadMatchToggleComponent} from './components/fields/broad-match-toggle/broad-match-toggle.component';
import {EmptyResultMessageComponent} from './components/fields/empty-result-message/empty-result-message.component';
import {UserUpdatesModalComponent} from './components/user-updates-modal/user-updates-modal.component';
import {DonutChartComponent} from './components/donut-chart/donut-chart.component';
import {SearchSelectWithLabelComponent} from './components/search-select-with-label/search-select-with-label.component';
import {ColorPickerComponent} from './components/color-picker/color-picker.component';
import {LabelsListComponent} from './components/labels-list/labels-list.component';
import {SearchSelectItemDirective} from './directives/search-select-item.directive';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';

@NgModule({
    imports: [
        FormsModule,
        HttpModule,
        RouterModule,
        CommonModule,
        NgHighlightModule,
        ReactiveFormsModule,
        VirtualScrollerModule
    ],
    declarations: [
        FilterComponent,
        SpinnerComponent,
        PaginationComponent,
        RecipientsFilterViewComponent,
        ViewAttachmentModalComponent,
        SearchSelectComponent,
        SvgCheckedComponent,
        SvgHalfCheckedComponent,
        SearchInstructionsModalComponent,
        ScrollableDirective,
        SignatureFieldComponent,
        FiltersViewComponent,
        QuickSearchComponent,
        BroadMatchToggleComponent,
        UserUpdatesModalComponent,
        EmptyResultMessageComponent,
        DonutChartComponent,
        SearchSelectWithLabelComponent,
        ColorPickerComponent,
        LabelsListComponent,
        SearchSelectItemDirective,
    ],
    exports: [
        FilterComponent,
        SpinnerComponent,
        PaginationComponent,
        RecipientsFilterViewComponent,
        ViewAttachmentModalComponent,
        SearchSelectComponent,
        SvgCheckedComponent,
        SvgHalfCheckedComponent,
        SearchInstructionsModalComponent,
        ScrollableDirective,
        SignatureFieldComponent,
        FiltersViewComponent,
        QuickSearchComponent,
        BroadMatchToggleComponent,
        UserUpdatesModalComponent,
        EmptyResultMessageComponent,
        DonutChartComponent,
        SearchSelectWithLabelComponent,
        DonutChartComponent,
        ColorPickerComponent,
        LabelsListComponent,
        SearchSelectItemDirective,
    ]
})
export class CommonComponentsModule {
}



// WEBPACK FOOTER //
// /app/src/app/common-components.module.ts